import ModalTemplate from 'components/modals/ModalTemplate';
import React from 'react'
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import Button from "@leafygreen-ui/button"

export default function ModalPrintedFilmsInventory({
  modalIsOpen,
  setModalIsOpen,
  title,
  mode,
  item,
  setItem,
  submitHandler,
  handleDelete,
  user
}) {
  const formRef = React.useRef();
  // console.log("formRef", formRef);
  // console.log("- item: ", item);

  const handleSubmit = (e) => {
    e.preventDefault();
    formRef.current.reportValidity();
    if (formRef.current.checkValidity()) submitHandler();
  };

  const onChangeHandler = (e) => {
    // console.log('* onChangeHandler init')
    // console.log(e.target.id, e.target.value);
    setItem({ ...item, [e.target.id]: e.target.value.trim() });
  };

  return (
    <ModalTemplate
      title={title}
      subTitle={mode}
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
      modalSize={{ width: "400px", height: "auto" }}
    >
      <form ref={formRef} className="card modal-form" >
        <div className="input-field">
          <label htmlFor="graphicFilename">
            Graphic File Name(Film id)
          </label>
          <input
            id="graphicFilename"
            type="text"
            value={item.graphicFilename ? item.graphicFilename : ""}
            onChange={onChangeHandler}
            placeholder="Graphic File Name"
            required={true}
            autoFocus
          />
        </div>
        <div className="input-field">
          <label htmlFor="areaCode">
            Inventory Location Code
          </label>
          <input
            id="areaCode"
            type="text"
            value={item.areaCode ? item.areaCode : ""}
            onChange={onChangeHandler}
            placeholder="Inventory Location Code"
            required={true}
          />
        </div>
        <div className="input-field">
          <label htmlFor="stock">
            Stock Quantity
          </label>
          <input
            id="stock"
            type="number"
            value={item.stock ? item.stock : 0}
            onChange={onChangeHandler}
            placeholder="Stock Qty"
            min="0"
            required={true}
          />
        </div>
        <div className="input-field">
          <label htmlFor="lowStock">
            Low Stock Threshold
          </label>
          <input
            id="lowStock"
            type="number"
            value={item.lowStock ? item.lowStock : 0}
            onChange={onChangeHandler}
            placeholder="Low Stock Threshold"
            min="0"
            required={true}
          />
        </div>
        <div className="input-field">
          <label htmlFor="anticipatedStock">
            Anticipated Stock
          </label>
          <input
            id="anticipatedStock"
            type="number"
            value={item.anticipatedStock ? item.anticipatedStock : 0}
            onChange={onChangeHandler}
            placeholder="Anticipated stock"
            min="0"
            required={true}
          />
        </div>

        <div className="modal-footer">
          {(mode.includes('update') && (user && user.role==="admin")) && (
            <Button
              variant="danger"
              className="swing-icon"
              onClick={handleDelete}
              leftGlyph={<FaTrashAlt />}
            >
              Delete
            </Button>
          )}
              
          <Button variant="primary" onClick={handleSubmit} className="swing-icon" leftGlyph={<FaSave />}>
            Submit
          </Button>

        </div>
      </form>
    </ModalTemplate>
  )
}
